import React, { useState } from "react";

import { InsightsStrings, valueStrings } from "constants/constantStrings";
import { DATE_FORMAT_WITH_BITWISEOR } from "constants/globalConstants";

import DupontIconButton from "components/DupontIconButton";

import RecommendationIcon from "assets/Insights/recommendation_Icon.svg";
import InsightIcon from "assets/SvgIcon/InsightIcon/index.js";
import ZoomIcon from "assets/SvgIcon/ZoomIcon/index.js";

import { formatDateLocalTZ, isFIT_1_AnamolyType } from "../../../utils/utils.js";

import SmartInsightPopup from "./SmartInsightPopup.jsx";

import "../index.scss";

const SmartInsightCard = ({ value, isToShowIcon = false, customClass }) => {
  const [isToPreview, setPreview] = useState(false);

  const openModal = () => setPreview(true);

  const handleClose = () => setPreview(false);

  const getTagId = value => {
    let tagId = isFIT_1_AnamolyType(value.AnomalyType) ? InsightsStrings.feedTag : InsightsStrings.brineTag;
    tagId = tagId.replace("[%]", value.Id);
    return tagId;
  };

  return (
    <div className={`insight-card ${customClass} `}>
      <div className="flex-between marginBtm10 ">
        <div className="fullWidth">
          <div className="flex-between">
            <h1>{isFIT_1_AnamolyType(value.AnomalyType) ? InsightsStrings.feedFlow : InsightsStrings.brineFlow}</h1>
            {isToShowIcon && (
              <DupontIconButton tooltip={valueStrings.zoom} onClick={openModal}>
                <ZoomIcon />
              </DupontIconButton>
            )}
          </div>
          <h2>{getTagId(value)}</h2>
          <h4>
            {InsightsStrings.start}
            {formatDateLocalTZ(value.CycleStartTime, DATE_FORMAT_WITH_BITWISEOR)}
          </h4>
          <h4>
            {InsightsStrings.end}
            {formatDateLocalTZ(value.CycleEndTime, DATE_FORMAT_WITH_BITWISEOR)}
          </h4>
        </div>
      </div>
      <span>
        <InsightIcon />
        {InsightsStrings.insight}
      </span>
      <h4>{isFIT_1_AnamolyType(value.AnomalyType) ? InsightsStrings.insightfeed : InsightsStrings.insightBrine}</h4>
      <div className="recommendation-container margin-bottom-10 ">
        <div className="margin-top-5">
          <img src={RecommendationIcon} alt="recommendationIcon" />
          {InsightsStrings.recommendation}
        </div>
        <h4>{InsightsStrings.recommendationDescription}</h4>
      </div>

      {isToShowIcon && (
        <div className="flex-center-center">
          <SmartInsightPopup value={value} handleClose={handleClose} open={isToPreview} type={value.AnomalyType} />
        </div>
      )}
    </div>
  );
};

export default SmartInsightCard;
